<template>
  <div class="container mt-5">
    <div class="row">
      <div class="col-8">
        <object
          v-if="
            opportunity.sign_request && opportunity.sign_request.signed_pdf_data
          "
          v-bind:data="pdfData"
          type="application/pdf"
          width="100%"
          height="1200px"
        ></object>
        <div v-else>
          <div v-if="html" v-html="html" class="document-preview"></div>
        </div>
      </div>

      <div class="col-4">
        <div class="card" v-if="opportunity.status != 'Signed'">
          <div class="card-header">
            <h4 class="card-header-title">Send Email</h4>
          </div>

          <div class="card-body">
            <p>
              To: {{ opportunity.contact.name }},
              {{ opportunity.contact.email }}
            </p>
            <p>
              From: {{ opportunity.user.name }}, {{ opportunity.user.email }}
            </p>
            <h4>Message:</h4>
            <p>Hi {{ opportunity.contact.first_name }},</p>

            <wysiwyg-inline
              :content="message"
              :save="saveHtml"
              v-if="message"
            ></wysiwyg-inline>

            <p>Kind regards,</p>
            <p>{{ opportunity.user.name }}</p>
          </div>

          <div class="card-footer text-end">
            <ladda-button :type="'primary'" :on-click="confirmSendEmail"
              >Send</ladda-button
            >
          </div>
        </div>

        <div class="card" v-if="opportunity.status != 'Signed'">
          <div class="card-header">
            <h4 class="card-header-title">Actions</h4>
          </div>
          <div class="card-body">
            <p>Generate Sign link or update document.</p>
            <ladda-button :type="'info'" :on-click="generateLink"
              >Generate Link</ladda-button
            >

            <div
              class="row"
              v-if="
                opportunity.sign_request &&
                opportunity.sign_request.sign_request_id
              "
            >
              <div class="col-12">
                <div class="form-group form-group-material">
                  <label
                    style="cursor: pointer"
                    class="control-label"
                    v-on:click="copyToClipboard()"
                    ><i class="fas fa-copy"></i>&nbsp;Sign Link</label
                  >
                  <input
                    name="name"
                    v-model="opportunity.sign_request.sign_url"
                    type="text"
                    class="form-control"
                    id="sign_url"
                  />
                </div>
              </div>
            </div>

            <p>Download DRAFT PDF.</p>
            <ladda-button :type="'info'" :on-click="generateLink"
              >Download Draft</ladda-button
            >

            <div
              v-show="
                opportunity.sign_request &&
                opportunity.sign_request.sign_request_id
              "
            >
              <hr />
              <p>
                Remove access to proposal. If this signing request is resent a
                new URL link will be set.
              </p>
              <ladda-button :type="'warning'" :on-click="confirmWithdraw"
                >Withdraw Signing Request</ladda-button
              >
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h4 class="card-header-title">Events</h4>
          </div>
          <div class="card-body">
            <table class="table" v-if="opportunity.sign_request">
              <tr>
                <th>Type</th>
                <th>IP</th>
                <th>Date</th>
              </tr>

              <tr
                v-for="event in opportunity.sign_request.events"
                v-bind:key="event.id"
              >
                <td>{{ event.action }}</td>
                <td>{{ event.ip }}sdf</td>
                <td>{{ event.created_at | moment("DD/MM/YYYY h:mm A") }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http, notify } from "utils";
import { WysiwygInline } from "components/form/input";
import { mapState, mapActions, mapGetters } from "vuex";

import LaddaButton from "components/form/input/ladda-button.vue";

export default {
  components: {
    WysiwygInline,
    LaddaButton,
  },
  data: function () {
    return {
      html: null,
      quoteGenerating: false,
      message: "Please find below link to requested proposal.",
    };
  },
  computed: {
    ...mapState("opportunity", {
      opportunity: "single",
    }),
    ...mapGetters("opportunity", ["isSigned"]),
    pdfData() {
      return (
        "data:application/pdf;base64," +
        this.opportunity.sign_request.signed_pdf_data
      );
    },
  },
  mounted() {
    this.getQuoteHtml();
  },
  methods: {
    ...mapActions("opportunity", ["getSingle"]),
    saveHtml(message) {
      this.message = message;
      return new Promise(() => {});
    },
    confirmSendEmail() {
      return this.$swal({
        title: "Send Email",
        html: "Are you sure you want to email the contact?",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Send Email",
      }).then(() => {
        return this.sendForSigning();
      });
    },
    confirmWithdraw() {
      return this.$swal({
        title: "Withdraw Signing Request",
        html: "Are you sure you want to withdraw this signing request?",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Withdraw",
      }).then(() => {
        return this.withdraw();
      });
    },
    getQuoteHtml() {
      http
        .get("/opportunities/" + this.opportunity.id + "/html-quote")
        .then((response) => {
          this.html = response.data;
        })
        .catch(function () {
          //reject();
        });
    },
    withdraw() {
      return http
        .delete(`/sign-request/${this.opportunity.sign_request.id}/withdraw`)
        .then((response) => {
          this.getSingle(this.opportunity.id).then(() => {
            notify.success("Removed from signing system");
          });
        })
        .catch(function (error) {
          if (
            error.response &&
            error.response.status &&
            error.response.status === 422
          ) {
            notify.error(
              "Form validation failed, please check your inputs and try again."
            );
          } else if (error.response) {
            notify.error(
              "API Error: " +
                error.response.status +
                " <br> " +
                error.response.statusText
            );
          }
        });
    },
    generateLink() {
      return http
        .post(`/opportunities/${this.opportunity.id}/sendForSigning`, {
          email: false,
          message: this.message,
        })
        .then((response) => {
          this.getSingle(this.opportunity.id).then(() => {
            notify.success(
              "Link generated and sent to signing system successfully"
            );
          });
        });
    },
    sendForSigning() {
      this.quoteGenerating = true;

      return http
        .post(`/opportunities/${this.opportunity.id}/sendForSigning`, {
          email: true,
          message: this.message,
        })
        .then((response) => {
          this.getSingle(this.opportunity.id).then(() => {
            this.quoteGenerating = false;
            notify.success(
              "Link generated and sent to signing system successfully"
            );
          });
        });
    },
    copyToClipboard() {
      var copyText = document.getElementById("sign_url");
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
    },
  },
};
</script>
